import * as React from "react";
import { cn } from "../shared/ui/index.ts";

export function TasksWidget() {
  const tasks = [
    { label: "Signer les ordonnances en attente", count: 4, urgent: true },
    { label: "Compte-rendu — Mme Bernard", count: 1, urgent: false },
    { label: "Rappeler le laboratoire Cerba", count: 1, urgent: false },
    { label: "Valider les arrêts de travail", count: 2, urgent: false },
  ];
  const [done, setDone] = React.useState<number[]>([]);
  return (
    <div className="flex flex-col gap-1">
      {tasks.map((t, i) => {
        const isDone = done.includes(i);
        return (
          <label
            key={i}
            className="flex cursor-pointer items-center gap-2.5 rounded-md px-1 py-2"
          >
            <input
              type="checkbox"
              checked={isDone}
              onChange={() =>
                setDone((d) =>
                  d.includes(i) ? d.filter((x) => x !== i) : [...d, i],
                )
              }
              className="size-4 accent-sf-primary"
            />
            <span
              className={cn(
                "flex-1 text-[13px]",
                isDone ? "text-sf-text-muted line-through" : "text-sf-text",
              )}
            >
              {t.label}
            </span>
            {t.urgent && !isDone && (
              <span className="rounded border border-sf-danger/25 bg-sf-danger/10 px-1.5 py-px text-[10px] font-semibold text-sf-danger">
                URGENT
              </span>
            )}
            <span className="inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-sf-surface-2 px-1.5 text-[11px] font-semibold text-sf-text-secondary">
              {t.count}
            </span>
          </label>
        );
      })}
    </div>
  );
}
